
import { computed, defineComponent, PropType } from "vue";
import { BasicUserInfoPartial } from "@/ts/objects/value/basic-user-info";
import { isStringBlank } from "@/ts/utils/common-util";
import TextBalloon from "@/components/balloons/TextBalloon/TextBalloon.vue";
import { useHovering } from "@/composables/use-hovering";
import { userEditPagePathOrHome } from "@/router/path-constructors";

export default defineComponent({
  name: "UserEditTableItemReadonlyUsers",
  components: { TextBalloon },
  props: {
    value: { type: Array as PropType<BasicUserInfoPartial[]>, required: true },
    /**
     * 編集中ならtrue。
     * ただし、この項目を編集できるわけではなく、多少挙動が変わるだけ。
     */
    editing: { type: Boolean, required: true },
  },
  setup(props) {
    const { hovering, onMouseEnter, onMouseLeave } = useHovering(1000);

    const items = computed<Item[]>(() =>
      props.value.map((u) => ({
        userId: u.userId,
        displayValue: (isStringBlank(u.name) ? u.googleMail : u.name) ?? "",
        linkPath: userEditPagePathOrHome(u.userType, u.userId),
      })),
    );

    return {
      hovering,
      onMouseEnter,
      onMouseLeave,

      items,
    };
  },
});

type Item = {
  readonly userId: string;
  readonly displayValue: string;
  readonly linkPath: string;
};
